// extracted by css-extract-rspack-plugin
export default {"page":"GuidePage-module__page___T7oej","content":"GuidePage-module__content___l3FLt","cardContent":"GuidePage-module__cardContent___RtHQ0"};